import { studioMediaPath } from './studioMedia';

const asset = (filename) => studioMediaPath(filename);

const option = (label, filename, videoFilename) => ({
	label,
	image: asset(filename),
	...(videoFilename ? { video: asset(videoFilename) } : {}),
});

/** Linear wizard steps used for back navigation — matches template `studioFlow`. */
export const STUDIO_FLOW = [
	'gender',
	'ethnicity',
	'age',
	'hairstyle',
	'haircolor',
	'bodytype',
	'eyecolor',
	'intimatesize',
	'final',
];

export const STUDIO_UI_FLOW = [...STUDIO_FLOW, 'generating', 'result'];

export const STUDIO_STEPS_BY_GENDER = {
	woman: [
		'gender',
		'ethnicity',
		'age',
		'hairstyle',
		'haircolor',
		'bodytype',
		'eyecolor',
		'intimatesize',
		'final',
		'generating',
		'result',
	],
	men: [
		'gender',
		'ethnicity',
		'age',
		'hairstyle',
		'haircolor',
		'bodytype',
		'eyecolor',
		'intimatesize',
		'final',
		'generating',
		'result',
	],
	trans: [
		'gender',
		'ethnicity',
		'age',
		'hairstyle',
		'haircolor',
		'bodytype',
		'eyecolor',
		'intimatesize',
		'final',
		'generating',
		'result',
	],
};

export const STUDIO_ETHNICITY = {
	woman: [
		option('Caucasian', 'ethnicity-caucasian.jpeg', 'ethnicity-caucasian.mp4'),
		option('Hispanic', 'ethnicity-hispanic.jpeg', 'ethnicity-hispanic.mp4'),
		option('Asian', 'ethnicity-asian.jpeg', 'ethnicity-asian.mp4'),
		option('African', 'ethnicity-african.jpeg', 'ethnicity-african.mp4'),
		option('Mixed', 'ethnicity-mixed.jpeg', 'ethnicity-mixed.mp4'),
		option('South Asian', 'ethnicity-south-asian.jpeg', 'ethnicity-south-asian.mp4'),
		option('Native American', 'ethnicity-native-american.jpeg', 'ethnicity-native-american.mp4'),
		option('Middle Eastern', 'ethnicity-middle-eastern.jpeg', 'ethnicity-middle-eastern.mp4'),
		option('Arab', 'ethnicity-arab.jpeg', 'ethnicity-arab.mp4'),
	],
	trans: [
		option('African', 'ethnicity-trans-african.jpeg'),
		option('Asian', 'ethnicity-trans-asian.jpeg'),
		option('Caucasian', 'ethnicity-trans-caucasian.jpeg'),
	],
	men: [
		option('African', 'ethnicity-men-african.jpeg'),
		option('Asian', 'ethnicity-men-asian.jpeg'),
		option('Caucasian', 'ethnicity-men-caucasian.jpeg'),
	],
};

export const STUDIO_HAIRSTYLE = {
	men: [
		option('Crew cut', 'hairstyle-men-crew-cut.jpeg'),
		option('Buzz cut', 'hairstyle-men-buzz-cut.jpeg'),
		option('Curly hair', 'hairstyle-men-curly-hair.jpeg'),
		option('Bald hair', 'hairstyle-men-bald-hair.jpeg'),
		option('Man bun', 'hairstyle-men-man-bun.jpeg'),
	],
	woman: [
		option('Long straight hair', 'hairstyle-woman-long-straight-hair.jpeg'),
		option('Pixie cut', 'hairstyle-woman-pixie-cut.jpeg'),
		option('Layered hair', 'hairstyle-woman-layered-hair.jpeg'),
		option('Voluminous curls', 'hairstyle-woman-voluminous-curls.jpeg'),
		option('Space buns', 'hairstyle-woman-space-buns.jpeg'),
		option('Ponytail', 'hairstyle-woman-ponytail.jpeg'),
		option('Long hair', 'hairstyle-woman-long-hair.jpeg'),
		option('Short bob', 'hairstyle-woman-short-bob.jpeg'),
	],
	trans: [
		option('Long layers', 'hairstyle-trans-long-layers.jpeg'),
		option('Short bob', 'hairstyle-trans-short-bob.jpeg'),
		option('Wavy', 'hairstyle-trans-wavy.jpeg'),
		option('Ponytail', 'hairstyle-trans-ponytail.jpeg'),
		option('Long', 'hairstyle-trans-long.jpeg'),
	],
};

export const STUDIO_HAIRCOLOR = {
	woman: [
		option('Blonde hair', 'haircolor-woman-blonde-hair.jpeg'),
		option('Platinum blonde hair', 'haircolor-woman-platinum-blonde-hair.jpeg'),
		option('Red hair', 'haircolor-woman-red-hair.jpeg'),
		option('Pink purple blue', 'haircolor-woman-pink-purple-blue.jpeg'),
		option('Black hair', 'haircolor-woman-black-hair.jpeg'),
		option('Honey blonde ombre', 'haircolor-woman-honey-blonde-ombre.jpeg'),
		option('Strawberry blonde hair', 'haircolor-woman-strawberry-blonde-hair.jpeg'),
		option('Brown hair', 'haircolor-woman-brown-hair.jpeg'),
	],
	men: [
		option('Black hair', 'haircolor-men-black-hair.jpeg'),
		option('Dirty blonde hair', 'haircolor-men-dirty-blonde-hair.jpeg'),
		option('Light brown hair', 'haircolor-men-light-brown-hair.jpeg'),
		option('Salt-and-pepper hair', 'haircolor-men-salt-and-pepper-hair.jpeg'),
		option('Fantasy purple hair', 'haircolor-men-fantasy-purple-hair.jpeg'),
	],
	trans: [
		option('Fantasy purple hair', 'haircolor-trans-fantasy-purple-hair.jpeg'),
		option('Black hair', 'haircolor-trans-black-hair.jpeg'),
		option('Blonde hair', 'haircolor-trans-blonde-hair.jpeg'),
		option('Dark brown hair', 'haircolor-trans-dark-brown-hair.jpeg'),
		option('Brunette', 'haircolor-trans-brunette.jpeg'),
	],
};

export const STUDIO_BODYTYPE = {
	woman: [
		option('Skinny', 'bodytype-woman-skinny.png'),
		option('Athletic', 'bodytype-woman-athletic.png'),
		option('Average', 'bodytype-woman-average.png'),
		option('Curvy', 'bodytype-woman-curvy.png'),
		option('Chubby', 'bodytype-woman-chubby.png'),
	],
	men: [
		option('Chubby', 'bodytype-men-chubby.jpeg'),
		option('Muscular', 'bodytype-men-muscular.jpeg'),
		option('Average', 'bodytype-men-average.jpeg'),
		option('Skinny', 'bodytype-men-skinny.jpeg'),
		option('Athletic', 'bodytype-men-athletic.jpeg'),
	],
	trans: [
		option('Skinny', 'bodytype-woman-skinny.png'),
		option('Athletic', 'bodytype-woman-athletic.png'),
		option('Average', 'bodytype-woman-average.png'),
		option('Curvy', 'bodytype-woman-curvy.png'),
		option('Chubby', 'bodytype-woman-chubby.png'),
	],
};

export const STUDIO_EYECOLOR = {
	woman: [
		option('Grey', 'eyecolor-woman-grey.jpeg'),
		option('Hazel', 'eyecolor-woman-hazel.jpeg'),
		option('Green', 'eyecolor-woman-green.jpeg'),
		option('Blue', 'eyecolor-woman-blue.jpeg'),
		option('Brown', 'eyecolor-woman-brown.jpeg'),
	],
	men: [
		option('Grey', 'eyecolor-men-grey.jpeg'),
		option('Hazel', 'eyecolor-men-hazel.jpeg'),
		option('Green', 'eyecolor-men-green.jpeg'),
		option('Brown', 'eyecolor-men-brown.jpeg'),
		option('Blue', 'eyecolor-men-blue.jpeg'),
	],
	trans: [
		option('Grey', 'eyecolor-woman-grey.jpeg'),
		option('Hazel', 'eyecolor-woman-hazel.jpeg'),
		option('Green', 'eyecolor-woman-green.jpeg'),
		option('Blue', 'eyecolor-woman-blue.jpeg'),
		option('Brown', 'eyecolor-woman-brown.jpeg'),
	],
};

export const STUDIO_BREASTSIZE = {
	woman: [
		option('Small', 'breastsize-woman-small.jpeg'),
		option('Medium', 'breastsize-woman-medium.jpeg'),
		option('Large', 'breastsize-woman-large.jpeg'),
		option('Extra large', 'breastsize-woman-extra-large.jpeg'),
	],
	trans: [
		option('Small', 'breastsize-woman-small.jpeg'),
		option('Medium', 'breastsize-woman-medium.jpeg'),
		option('Large', 'breastsize-woman-large.jpeg'),
		option('Extra large', 'breastsize-woman-extra-large.jpeg'),
	],
};

export const STUDIO_BULGESIZE = {
	men: [
		option('None', 'bodytype-men-skinny.jpeg'),
		option('Normal', 'bodytype-men-average.jpeg'),
		option('Big', 'bodytype-men-athletic.jpeg'),
	],
};

export const STUDIO_OPTIONS_BY_STEP = {
	ethnicity: STUDIO_ETHNICITY,
	hairstyle: STUDIO_HAIRSTYLE,
	haircolor: STUDIO_HAIRCOLOR,
	bodytype: STUDIO_BODYTYPE,
	eyecolor: STUDIO_EYECOLOR,
	intimatesize: {
		woman: STUDIO_BREASTSIZE.woman,
		trans: STUDIO_BREASTSIZE.trans,
		men: STUDIO_BULGESIZE.men,
	},
	breastsize: STUDIO_BREASTSIZE,
};
